import React from "react";
import Dashboard_buckets_card from "../../../../../common_components/dashboard_buckets_card/Dashboard_buckets_card";

function Hotel_dashboard_buckets() {
  // Data Array
  const bucketData = [
    {
      imgSrc: "/assets/images/icon/girls_boys.webp",
      number: "25",
      heading_text: "Total Interns",
      text: "Total interns at all stages"
    },
    {
      imgSrc: "/assets/images/icon/people_right.webp",
      number: "12",
      heading_text: "Active Interns",
      text: "Interns currently working"
    },
    {
      imgSrc: "/assets/images/icon/bag_fly.webp",
      number: "€800",
      heading_text: "Arriving Soon",
      text: "Interns arriving soon"
    },

       {
      imgSrc: "/assets/images/icon/circle_check.webp",
      number: "€800",
      heading_text: "In Processing",
      text: "Applications in progress"
    },
   
  ];

  return (
    <>
      <section className="Dashboard_buckets Collage_dashboard_buckets">
        <div className="heading_text_holder">
          <h2>Welcome Hotel Le Royal</h2>
        </div>

        <div className="row">
          {bucketData.map((item, index) => (
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3" key={index}>
              <Dashboard_buckets_card
                imgSrc={item.imgSrc}
                number={item.number}
                heading_text={item.heading_text}
                text={item.text}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Hotel_dashboard_buckets;